<template>
  <v-card outlined :class="{ 'invoice-product-entry--edit': editMode }">
    <v-card-text v-if="editMode" class="invoice-product-entry__compact">
      <div class="invoice-product-entry__grid">
        <v-autocomplete v-model="selectedProduct" hide-no-data ref="productSearch" outlined
          :loading="productSearchLoading" prepend-inner-icon="mdi-magnify" dense auto-select-first
          :error-messages="error" :hide-details="error.length === 0" clearable eager
          :items="Products" item-text="name" return-object :search-input.sync="phoneSearch"
          label="Search products">
          <template slot="item" slot-scope="{ item }">
            <span>{{ item.name }}</span>
            <v-spacer />
            <v-chip v-if="item.isFee" color="primary" outlined x-small>School fee</v-chip>
          </template>
        </v-autocomplete>
        <v-text-field v-model="name" ref="itemName" label="Item name" outlined dense hide-details autocomplete
          @focus="$event.target.select()" @keyup.enter="$refs.unitPrice.focus" />
        <v-text-field v-model="price" ref="unitPrice" class="amount-input" label="Amount" prefix="$" outlined dense type="number"
          hide-details @focus="$event.target.select()" @keyup.enter="submit" />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn ref="addbutton" class="invoice-product-entry__add" color="primary" depressed
              aria-label="Add item to invoice" v-bind="attrs" v-on="on" @click="submit">
              <v-icon>mdi-cart-arrow-down</v-icon>
            </v-btn>
          </template>
          <span>Add item to invoice</span>
        </v-tooltip>
      </div>
    </v-card-text>

    <v-card-text v-else>
      <v-layout row wrap align-center justify-space-between fill-height>
        <v-flex xs12 sm3>
          <v-autocomplete v-model="selectedProduct" hide-no-data ref="productSearch" outlined
            :loading="productSearchLoading" prepend-inner-icon="search" rounded allow-overflow dense auto-select-first
            single-line :error-messages="error" :hide-details="error.length === 0" clearable eager id="productSearch"
            :items="Products" item-text="name" return-object :search-input.sync="phoneSearch"
            :label="$t('labels.searchProduct')">
            <template slot="item" slot-scope="{ item }">
              <span>{{ item.name }}</span>
              <v-spacer></v-spacer>
              <v-chip v-if="item.isFee" color="pink" label text-color="white">
                <v-icon left>
                  mdi-label
                </v-icon>
                School Fee
              </v-chip>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm3>
          <v-text-field @focus="$event.target.select()" label="Item Name" @keyup.enter="$refs.qty.focus" v-model="name"
            outlined dense hide-details autocomplete ref="itemName"></v-text-field>
        </v-flex>
        <v-flex xs12 sm1>
          <v-text-field class="centered-input" @focus="$event.target.select()" ref="qty" :disabled="disabledQty"
            label="Quantity" outlined dense type="number" hide-details @keyup.enter="$refs.unitPrice.focus"
            v-model="qty"></v-text-field>
        </v-flex>
        <v-flex xs12 sm2>
          <v-text-field class="right-input" @keyup.enter="submit" ref="unitPrice" @focus="$event.target.select()"
            label="Unit Price" v-model="price" outlined type="number" dense hide-details></v-text-field>
        </v-flex>
        <v-flex xs12 sm2>
          <v-text-field class="right-input" ref="extAmount" disabled outlined dense hide-details
            @focus="$event.target.select()" v-model="total" label="Ext Amount"></v-text-field>
        </v-flex>
        <v-flex d-flex xs12 sm1>
          <v-btn color="info" ref="addbutton" large @click="submit">
            Add
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>

    <v-dialog persistent scrollable v-model="dialog" max-width="600">
      <v-card :loading="loadingNumber" class="profile-dialog-card entity-form-dialog student-fe-dialog">
        <EntityDialogHeader eyebrow="Invoice item" title="Add Student Fee"
          subtitle="Choose the student and the department this fee belongs to."
          icon="mdi-account-cash-outline" close-label="Close add student fee dialog" @close="closeDialog" />

        <v-divider />

        <v-card-text class="profile-dialog-body entity-form-dialog__body">
          <section class="entity-form-dialog__section">
            <div class="entity-form-dialog__section-heading">
              <span><v-icon size="19" color="primary">mdi-account-outline</v-icon></span>
              <div>
                <h3>Student</h3>
                <p>Select the student receiving this charge.</p>
              </div>
            </div>
            <v-autocomplete v-model="selectedStudent" :items="Students" :loading="loadingNumber"
              item-text="fullName" return-object clearable outlined dense hide-details label="Student">
              <template slot="item" slot-scope="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.fullName }}</v-list-item-title>
                  <v-list-item-subtitle>{{ departmentCountLabel(item) }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-chip small color="grey lighten-4">
                  <v-icon left small>mdi-school-outline</v-icon>{{ departmentCount(item) }}
                </v-chip>
              </template>
            </v-autocomplete>
          </section>

          <section v-if="selectedStudent" class="entity-form-dialog__section">
            <div class="entity-form-dialog__section-heading">
              <span><v-icon size="19" color="primary">mdi-school-outline</v-icon></span>
              <div>
                <h3>Department</h3>
                <p v-if="studentDepartments.length === 1">The only assigned department is selected automatically.</p>
                <p v-else>Select which department fee to add.</p>
              </div>
            </div>
            <v-radio-group v-if="studentDepartments.length" v-model="selectedDepartment" hide-details
              class="student-fe-dialog__departments">
              <v-radio v-for="department in studentDepartments" :key="department.id" :value="department">
                <template v-slot:label>
                  <div class="student-fe-dialog__department-label">
                    <strong>{{ department.Class.name }}</strong>
                    <span>{{ departmentFee(department) | currency }} fee · {{ Number(department.parentPay || 0) | currency }} parent<span v-if="departmentMasjidPay(department)"> · {{ departmentMasjidPay(department) | currency }} Masjid</span></span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
            <v-alert v-else text type="warning" class="mb-0">This student is not assigned to a department.</v-alert>
          </section>
        </v-card-text>

        <v-divider />

        <v-card-actions class="profile-dialog-actions entity-form-dialog__actions">
          <v-btn text @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" depressed :disabled="!selectedStudent || !selectedDepartment" @click="saveStudent">
            <v-icon left small>mdi-plus</v-icon>Add fee
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog v-model="showErrorMessageDialog" persistent max-width="320">
      <v-card>
        <v-card-title class="headline"> Already Sold </v-card-title>
        <v-card-text>
          <div class="text-center">
            <div>
              <strong>{{ showErrorMessage }}</strong> if find this is a mistake
              click restock button to sale it
            </div>
            <div class="mt-2">
              <v-btn @click="restock" color="success">Restock</v-btn>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showErrorMessageDialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-card>
</template>

<script>
import productService from "@/modules/Product/service";
// import purchaseService from "@/modules/Inventory/Purchase/service";
import { mapGetters, mapActions } from "vuex";
import studentService from "@/modules/Student/service.js";

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showErrorMessageDialog: false,
      showErrorMessage: null,
      error: [],
      search: null,
      searchProduct: null,
      productSearchLoading: false,
      selectedStudent: null,
      selectedDepartment: null,
      Products: [],
      Students: [],
      serailList: [],
      headers: [
        {
          text: "SERIAL NUMBER",
          align: "start",
          sortable: true,
          value: "imeiNumber",
        },
        {
          text: "COST",
          align: "end",
          sortable: true,
          value: "cost",
        },
      ],
      loadingNumber: false,
      phoneSearch: null,
      selectedProduct: null,
      selected: [],
      name: null,
      disabledQty: false,
      qty: 1,
      price: 0,
      total: 0,
      dialog: false,
    };
  },
  created() {
    this.emptyEntryBar();
  },
  computed: {
    ...mapGetters("invoice", ["Invoice", "InvoiceDetails", "getSelectedCustomer"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    studentDepartments() {
      return this.selectedStudent && this.selectedStudent.ClassStudents
        ? this.selectedStudent.ClassStudents.filter(department => department.Class)
        : [];
    },
  },
  watch: {
    phoneSearch(val) {
      if (val && val.length === 1) {
        this.getProduct();
      }
      if (val && val.length > 1) this.error = [];
    },
    qty() {
      this.total = this.qty * this.price;
    },
    price(val) {
      this.total = val * this.qty;
    },
    selectedProduct(val) {
      if (val) {
        this.setProduct(val);
      }
    },
    selectedStudent(val) {
      this.selectedDepartment = val && this.studentDepartments.length === 1
        ? this.studentDepartments[0]
        : null;
    },
    dialog(val) {
      if (val) {
        this.loadingNumber = true;
        this.getStudent();
        // this.getSerialList(this.selectedProduct);
      }
    },
  },
  methods: {
    ...mapActions("invoice", ["AddInvoiceDetail", "UnDeleteInvoiceDetailRow"]),
    ...mapActions("global", ["PlaySound"]),
    departmentCount(student) {
      return student && student.ClassStudents ? student.ClassStudents.length : 0;
    },
    departmentCountLabel(student) {
      const count = this.departmentCount(student);
      return `${count} ${count === 1 ? "department" : "departments"}`;
    },
    departmentMasjidPay(department) {
      return Number(department.charity || 0);
    },
    departmentThirdPartyPay(department) {
      if (Array.isArray(department.TuitionSponsorships)) {
        return department.TuitionSponsorships.reduce((sum, sponsorship) => (
          sum + Number(sponsorship.amount || 0)
        ), 0);
      }
      return Number(department.thirdPartyPay || 0);
    },
    departmentFee(department) {
      return Number(department.parentPay || 0)
        + Number(department.charity || 0)
        + this.departmentThirdPartyPay(department)
        + Number(department.zakat || 0)
        + Number(department.payrollDeduction || 0);
    },
    getStudent() {
      return studentService.getAll({ CustomerId: this.getSelectedCustomer.id }).then((response) => {
        this.Students = response.data;
        console.log("response Students", this.Students);
        this.loadingNumber = false
        return response;
      });
    },
    
    closeDialog() {
      this.dialog = false;
      this.emptyEntryBar();
    },
    async getSerialList(product) {
      const list = await purchaseService.getAvailableSerial({
        ProductId: product.id,
      });
      this.serailList = list.data.rows;
      this.loadingNumber = false;
    },
    setProduct(product) {
      if (product) {
        this.price = product.price;
        this.total = product.price * this.qty;
        this.name = product.name;
        this.imeiNumber = product.imeiNumber | null;
        if (product.isFee) {
          this.disabledQty = true;
        } else {
          this.disabledQty = false;
        }
        if (product.imeiNumber) {
          setTimeout(() => {
            this.$refs.unitPrice.focus();
          }, 300);
          // this.$nextTick(() => {
          //   this.$refs.unitPrice.focus();
          // });
        } else {
          setTimeout(() => {
            this.$refs.itemName.focus();
          }, 300);
          // this.$nextTick(() => {
          //   this.$refs.itemName.focus();
          // });
        }
      }
    },
    emptyEntryBar() {
      this.name = null;
      this.qty = 1;
      this.total = 0;
      this.price = 0;
      this.phoneSearch = null;
      this.selectedProduct = null;
      this.selectedStudent = null;
      this.selectedDepartment = null;
      this.dialog = false;
      this.imeiNumber = false;
      this.Products = [];
      this.selected = [];
      setTimeout(() => {
        this.$refs.productSearch.focus();
      }, 300);
    },
    submit() {
      if (!this.selectedProduct) return false;
      if (this.selectedProduct.isFee) {
        this.dialog = true;
      } else {
        this.selectedProduct.Bar = {
          name: this.name,
          qty: 1,
          price: this.price,
        };
        this.$emit("submit", this.selectedProduct);
        this.emptyEntryBar();
      }
    },
    async saveStudent() {
      if (!this.selectedStudent || !this.selectedDepartment) return false;
      const department = this.selectedDepartment;
      const fee = this.departmentFee(department);
      this.AddInvoiceDetail({
        ProductId: this.selectedProduct.id,
        name: this.name,
        studentName: this.selectedStudent.fullName,
        description: department.Class.name,
        price: fee,
        total: fee,
        parentPay: Number(department.parentPay || 0),
        thirdPartyPay: this.departmentThirdPartyPay(department),
        zakat: Number(department.zakat || 0),
        payrollDeduction: Number(department.payrollDeduction || 0),
        PayrollTeacherId: department.PayrollTeacherId || null,
        StudentId: this.selectedStudent.id,
        ClassId: department.Class.id,
        ClassRoomId: department.ClassRoomId || null,
        qty: 1,
        cost: 0,
      });

      this.closeDialog();
    },
    getProduct() {
      return productService.getAll().then((result) => {
        // console.log("product", result);
        // { trackSerialNumber: false }
        const product = result.data;
        product.map((row) => {
          if (row.trackSerialNumber) {
            if (row.balance > 0) this.Products.push(row);
          } else {
            this.Products.push(row);
          }
        });
      });
    },
    async searchIMEI() {
      if (!this.phoneSearch) return false;
      if (this.selectedProduct) return false;

      const searchValue = {
        imeiNumber: this.phoneSearch,
      };

      const imeiResult = this.InvoiceDetails.findIndex((row) => {
        // console.log('searchValue.imeiNumber', searchValue.imeiNumber)
        // console.log(
        //   "searchValue.imeiNumber",
        //   row,
        //   searchValue.imeiNumber.toUpperCase()
        // );
        if (row.imeiNumber) row.imeiNumber = row.imeiNumber.toUpperCase();
        if (searchValue.imeiNumber)
          searchValue.imeiNumber = searchValue.imeiNumber.toUpperCase();
        if (row.imeiNumber === searchValue.imeiNumber) {
          return true;
        }
      });
      // console.log("passed!", imeiResult); //355299070455844

      if (imeiResult !== -1) {
        if (this.InvoiceDetails[imeiResult].delete) {
          await this.UnDeleteInvoiceDetailRow(imeiResult);
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "success",
              title: "Item was restore",
            });
          this.emptyEntryBar();
          return false;
        }
        this.error.push(`${searchValue.imeiNumber} is already in this list`);
        this.productSearchLoading = false;
        this.PlaySound("error");
        this.$swal
          .mixin({
            toast: true,
            position: "top-right",
            showConfirmButton: true,
            timer: 3000,
          })
          .fire({
            icon: "error",
            title: `${searchValue.imeiNumber} is already in this list`,
          });
        this.emptyEntryBar();
      } else {
        this.productSearchLoading = true;
        return purchaseService
          .search(searchValue)
          .then((response) => {
            console.log("response", response);
            if (response.data) {
              this.productSearchLoading = false;
              let product = response.data;
              // product.Product = response.data.Product
              product.Product.imeiNumber = this.phoneSearch;
              // console.log("response.data", response.data);
              // this.selectedProduct = response.data.Product;
              this.AddInvoiceDetail({
                ProductId: product.Product.id,
                name: product.Product.name,
                price: product.Product.price,
                total: product.Product.price * 1,
                qty: 1,
                cost: product.cost | 0,
                imeiNumber: product.imeiNumber,
              });

              this.emptyEntryBar();
            } else {
              // console.log("not found");
              this.error.push(
                `${this.phoneSearch} No Product with this serach`
              );
              this.productSearchLoading = false;
              this.PlaySound("error");
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-right",
                  showConfirmButton: true,
                  timer: 3000,
                })
                .fire({
                  icon: "error",
                  title: `${this.phoneSearch} No Product with this serach`,
                });
              // this.$swal({
              //   title: "Product Not Found",
              //   text: `${this.phoneSearch} No Product with this serach`,
              //   icon: "warning",
              // });
              this.emptyEntryBar();
            }
          })
          .catch((error) => {
            this.productSearchLoading = false;
            console.log("error", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.invoice-product-entry--edit {
  border-color: #dfe7e0;
  border-radius: 12px;
}

.invoice-product-entry--edit .v-card__text {
  padding: 12px;
}

.invoice-product-entry__grid {
  display: grid;
  align-items: center;
  gap: 10px;
  grid-template-columns: minmax(220px, 1.4fr) minmax(180px, 1fr) 170px 48px;
}

.invoice-product-entry__add {
  width: 48px;
  min-width: 48px !important;
  height: 40px !important;
}

.student-fe-dialog__departments {
  margin-top: 0;
}

.student-fe-dialog__departments ::v-deep .v-radio {
  min-height: 62px;
  margin: 0 0 8px;
  padding: 10px 12px;
  border: 1px solid #dfe7e0;
  border-radius: 9px;
}

.student-fe-dialog__departments ::v-deep .v-radio.v-item--active {
  border-color: var(--v-primary-base);
  background: #f5faf6;
}

.student-fe-dialog__department-label {
  display: flex;
  flex-direction: column;
}

.student-fe-dialog__department-label strong {
  color: #29382e;
  font-size: 14px;
}

.student-fe-dialog__department-label span {
  margin-top: 2px;
  color: #718077;
  font-size: 12px;
}

@media (max-width: 900px) {
  .invoice-product-entry__grid {
    grid-template-columns: minmax(180px, 1fr) minmax(160px, 1fr) 140px 48px;
  }
}

@media (max-width: 700px) {
  .invoice-product-entry--edit .v-card__text {
    padding: 14px;
  }

  .invoice-product-entry__grid {
    grid-template-columns: 1fr 48px;
  }

  .invoice-product-entry__grid > :first-child,
  .invoice-product-entry__grid > :nth-child(2) {
    grid-column: 1 / -1;
  }
}
</style>
